import _get from "lodash/get";
import _isUndefined from "lodash/isUndefined";
import { createAction } from 'redux-actions';
import domainName, { getDomainItems } from '../../utils/domainName';
/**
 * AUTH_COOKIE_NAME - the name of the authentication cookie
 * Use this cookie to authenticate requests to the Blocket API
 */

export var AUTH_COOKIE_NAME = 'session_secure';
var prefix = 'Blocket-login-helper:';
export var BLH_SET_CONFIG = "".concat(prefix, ": Set authFE configuration");
export var SHOW_LOGIN_TO_CONTINUE = "".concat(prefix, " show login to continue promt");
export var CLOSE_LOGIN_TO_CONTINUE = "".concat(prefix, " close login to continue promt");
var setConfig = createAction(BLH_SET_CONFIG);
var loginToContinue = createAction(SHOW_LOGIN_TO_CONTINUE);
var closeLoginToContinue = createAction(CLOSE_LOGIN_TO_CONTINUE);
export var availableCallbackIds = {
  beta: 'beta',
  mobil: 'chirp',
  www: 'desktop'
};
/**
 * Opens and closes the login to continue view
 * @param {boolean} showView - show or hide login to continue view
 */

var setLoginToContinue = function setLoginToContinue(loginAlert) {
  return function (dispatch) {
    window.document.body.style.overflow = loginAlert.isOpen ? 'hidden' : 'auto';
    return loginAlert.isOpen ? dispatch(loginToContinue(loginAlert)) : dispatch(closeLoginToContinue(loginAlert));
  };
};
/**
 * Redirects the user to the Blocket Login Helper login process
 * @param {string} successUri - the path to where the user should go when
 *            the user comes back from BLH
 * @param {string} cancelUri - the path to use then the user decides to
 *            cancel the login flow
 * @param {string} tag - the tracking identity
 * @param {string} method - only used for verification, method eg: 'sms', 'bankId'
 */


var goToLogin = function goToLogin(successUri, cancelUri, tag, method) {
  return function (dispatch, getState) {
    if (_isUndefined(successUri) || _isUndefined(cancelUri)) {
      throw new Error('Blocket login helper callback urls are not provided');
    }

    var blhUrl = _get(getState(), 'blocketLoginHelper.loginUrl', '');

    var currentUrl = domainName.getCurrentUrl();
    var name = getDomainItems(currentUrl)[0];
    var envName = name.split('-').pop();

    var callbackId = _get(availableCallbackIds, envName, 'beta');

    var verificationFlag = method ? "&verification=".concat(method) : '';
    window.location.assign("".concat(blhUrl, "?callbackId=").concat(callbackId, "&redirectUri=").concat(encodeURIComponent(successUri), "&cancelRedirectUri=").concat(encodeURIComponent(cancelUri), "&tag=").concat(tag).concat(verificationFlag));
  };
};
/**
 * Redirects the user to the Blocket Login Helper verification process
 * @param {string} successUri - the path to where the user should go when
 *            the user comes back from BLH
 * @param {string} cancelUri - the path to use then the user decides to
 *            cancel the login flow
 * @param {string} tag - the tracking identity
 * @param {string} method - the verification method eg: 'sms', 'bankId'
 */


var goToVerification = function goToVerification(successUri, cancelUri, tag, method) {
  return function (dispatch) {
    var validMethods = ['bankId', 'sms'];

    if (!validMethods.includes(method)) {
      throw new Error("Verification method/type must be one of strings: ".concat(validMethods));
    }

    dispatch(goToLogin(successUri, cancelUri, tag, method));
  };
};
/**
 * Redirects the user to Blocket Login Helper logout
 *
 * @param {string} successLogoutUri - the uri to redirect the user when
 *            the logout process has been completed
 */


var logout = function logout() {
  var successLogoutUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  return function (dispatch, getState) {
    var blhLogoutUrl = _get(getState(), 'blocketLoginHelper.logoutUrl', '');

    var currentUrl = domainName.getCurrentUrl();
    var name = getDomainItems(currentUrl)[0];
    var envName = name.split('-').pop();

    var callbackId = _get(availableCallbackIds, envName, 'beta');

    var redirectUri = encodeURIComponent(successLogoutUri);
    window.location.assign("".concat(blhLogoutUrl, "?callbackId=").concat(callbackId, "&redirectUri=").concat(redirectUri, "&cancelRedirectUri=").concat(redirectUri));
  };
};

export var actionCreators = {
  setConfig: setConfig,
  goToLogin: goToLogin,
  logout: logout,
  setLoginToContinue: setLoginToContinue,
  goToVerification: goToVerification
};
//# sourceMappingURL=actions.js.map